var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqlWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.78,322a92.49,92.49,0,0,0,46.8,13.2c26.7,0,42.3-14.1,42.3-34.5,0-18.9-10.8-29.7-38.1-40.2-33-11.7-53.4-28.8-53.4-57.3,0-31.5,26.1-54.9,65.4-54.9,20.7,0,35.7,4.8,44.7,9.9l-7.2,21.3a80.53,80.53,0,0,0-38.4-9.6c-27.6,0-38.1,16.5-38.1,30.3,0,18.9,12.3,28.2,40.2,39,34.2,13.2,51.6,29.7,51.6,59.4,0,31.2-23.1,58.2-70.8,58.2-19.5,0-40.8-5.7-51.6-12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.08,383.5c-27.3-7.2-54-15.3-77.4-23.4-4.2-1.5-8.4-3-12.3-3-48-1.8-89.1-37.2-89.1-102.3,0-64.8,39.6-106.5,94.2-106.5,54.9,0,90.6,42.6,90.6,102.3,0,51.9-24,85.2-57.6,96.9v1.2c20.1,5.1,42,9.9,59.1,12.9Zm-21.6-131.7c0-40.5-21-82.2-63.9-82.2-44.1,0-65.7,40.8-65.4,84.6-.3,42.9,23.4,81.6,64.2,81.6C300.08,335.8,323.48,298,323.48,251.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385,151.6h26.11V331.9h86.4v21.9H385Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlWhite);
export default __webpack_public_path__ + "static/media/sql-white.b99a7e42eda4f7367b71fc8dbb573c91.svg";
export { ForwardRef as ReactComponent };